"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSelectItems = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var lodash_1 = require("lodash");
var react_tiny_virtual_list_1 = __importDefault(require("react-tiny-virtual-list"));
var styled_1 = require("./styled");
var style_1 = require("../../../SelectionList/style");
var SearchSelectItems = function (props) {
    var _a = (0, react_1.useState)(null), active = _a[0], setActive = _a[1];
    var _b = (0, react_1.useState)(false), isKeyUpOrDownPressed = _b[0], setIsKeyUpOrDownPressed = _b[1];
    var findOptionsIndexValue = function (options, value) {
        return (0, lodash_1.findIndex)(options, function (v) {
            return !(0, lodash_1.isNil)(v === null || v === void 0 ? void 0 : v.value) &&
                !(0, lodash_1.isNil)(value) &&
                v.value.toString() === value.toString();
        });
    };
    (0, react_1.useEffect)(function () {
        if (props.invokeKeyPress !== 'NONE') {
            switch (props.invokeKeyPress) {
                case core_1.Keys.ARROW_DOWN:
                    onKeyDown();
                    break;
                case core_1.Keys.ARROW_UP:
                    onKeyUp();
                    break;
                case core_1.Keys.DELETE:
                    setIsKeyUpOrDownPressed(false);
                    props.allowEmpty && props.multi && setActive(-1);
                    props.onKeyPressed && props.onKeyPressed();
                    break;
                case core_1.Keys.ENTER:
                    if (props.options[active]) {
                        props.selectDeselectItem(props.options[active]);
                    }
                    props.onKeyPressed && props.onKeyPressed();
            }
        }
    }, [props.invokeKeyPress]);
    (0, react_1.useEffect)(function () {
        var index = findOptionsIndexValue(props.options, props.selection);
        setActive(index);
    }, [props.selection, props.options]);
    var onKeyUp = function () {
        active === 0 ? setActive(props.options.length - 1) : setActive(active - 1);
        setIsKeyUpOrDownPressed(true);
    };
    var onKeyDown = function () {
        active === props.options.length - 1 ? setActive(0) : setActive(active + 1);
        setIsKeyUpOrDownPressed(true);
    };
    var getSelectedLabel = function (option, index) {
        if (props.multi && (0, lodash_1.isArray)(props.selection)) {
            var value = option.value;
            return (react_1.default.createElement(styled_1.SelectItemCheckbox, { checked: props.selection.includes(value), onClick: function (e) {
                    e.preventDefault();
                    setActive(index);
                    props.selectDeselectItem(option);
                } }));
        }
        return null;
    };
    var notIncludeSearch = (0, react_1.useMemo)(function () {
        return !!props.search &&
            !props.options.find(function (item) { return item.label === props.search || item.label === props.search; });
    }, [props.options, props.search]);
    var getVirtualHeight = (0, react_1.useCallback)(function () {
        return props.options.length > 4 ? 150 : 30 * props.options.length + 1;
    }, [props.options]);
    return (react_1.default.createElement(style_1.NoFocusMenu, null,
        props.allowEmpty && !props.multi && (react_1.default.createElement(core_1.MenuItem, { active: !isKeyUpOrDownPressed && (active === -1 || props.selection === ''), className: 'select-item', text: 'No Selection', onClick: function () { return props.selectDeselectItem({ value: '', label: '' }); } })),
        props.options.length > 0 ? (react_1.default.createElement(react_tiny_virtual_list_1.default, { scrollToIndex: props.selection.length > 1
                ? findOptionsIndexValue(props.options, props.selection[0])
                : active, width: "100%", height: getVirtualHeight(), itemCount: props.options.length, itemSize: 30, renderItem: function (_a) {
                var _b;
                var index = _a.index, style = _a.style;
                return (react_1.default.createElement(core_1.MenuItem, { style: __assign(__assign({}, (props.displayAsTree && {
                        paddingLeft: props.displayAsTree &&
                            (0, lodash_1.get)(props.options, "[".concat(index, "].isParent"), false)
                            ? '7px'
                            : (_b = props === null || props === void 0 ? void 0 : props.treeChildIndentWidth) !== null && _b !== void 0 ? _b : '30px'
                    })), style), active: index === active, key: index, className: 'select-item', icon: props.options[index].icon, text: props.options[index].label, labelElement: getSelectedLabel(props.options[index], index), onClick: function (e) {
                        e.preventDefault();
                        props.selectDeselectItem(props.options[index]);
                    } }));
            } })) : !props.allowNewItem ? (react_1.default.createElement(core_1.MenuItem, { text: 'No results.', disabled: true })) : null,
        props.allowNewItem && notIncludeSearch && (react_1.default.createElement(core_1.MenuItem, { text: "Create ".concat(props.search), icon: 'add', onClick: function () { return props.onAddNewItem && props.onAddNewItem(); } }))));
};
exports.SearchSelectItems = SearchSelectItems;
